/* FENN: "6x de R$ xx,xx" ao lado do preço do cartão, igual ao layout offline (11/09/2026).
 * Lê o preço já desenhado pelo tema (ex.: "R$ 139,90"), divide por 6 e acrescenta um <small>. Idempotente e religado
 * por MutationObserver (o tema re-renderiza cartões em filtros, "carregar mais" e no editor).
 * 13/09/2026: passou a cobrir também o preço da própria página do produto (não só o dos cartões),
 * pra ficar igual ao layout offline de site-layout/produto.html. */
(function () {
  function brl(v) { return 'R$ ' + v.toFixed(2).replace('.', ','); }
  function ligar() {
    document.querySelectorAll("product-card product-price, main[data-template='product'] product-price").forEach(function (pp) {
      if (pp.querySelector('.fenn-parcela')) return;
      var m = (pp.textContent || '').match(/R\$\s*([\d.]+),(\d{2})/);
      if (!m) return;
      var valor = parseFloat(m[1].replace(/\./g, '') + '.' + m[2]);
      if (!(valor > 0)) return;
      var s = document.createElement('small');
      s.className = 'fenn-parcela';
      s.textContent = '6x de ' + brl(valor / 6);
      pp.appendChild(s);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar); else ligar();
  new MutationObserver(function () { ligar(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', ligar);
})();
